// @flow
import type { Action, State } from './types';

export const initialState: State = {
  questions: {
    securityQuestions: [],
    currentQuestion: '',
    error: false,
    fetching: false,
  },
  passcode: {
    fetching: false,
    error: false,
  },
};

const reducer = (state: State = initialState, action: Action): State => {
  switch (action.type) {
    case 'REQUEST_SECURITY_QUESTIONS':
      return {
        ...state,
        questions: {
          ...state.questions,
          error: false,
          fetching: true,
        },
      };
    case 'RECEIVE_SECURITY_QUESTIONS': {
      const { payload } = action;
      return {
        ...state,
        questions: {
          ...state.questions,
          fetching: false,
          error: false,
          securityQuestions: payload,
        },
      };
    }
    case 'REQUEST_SECURITY_QUESTIONS_ERROR':
      return {
        ...state,
        questions: {
          ...state.questions,
          error: true,
          fetching: false,
        },
      };
    case 'SET_SECURITY_ANSWER':
      return {
        ...state,
        questions: {
          ...state.questions,
          fetching: true,
          error: false,
        },
      };
    case 'SET_SECURITY_ANSWER_COMPLETE':
      return {
        ...state,
        questions: {
          ...state.questions,
          error: false,
          fetching: false,
        },
      };
    case 'SET_SECURITY_ANSWER_ERROR':
      return {
        ...state,
        questions: {
          ...state.questions,
          error: true,
          fetching: false,
        },
      };
    case 'REQUEST_VERIFY_PASSCODE':
      return {
        ...state,
        passcode: {
          fetching: true,
          error: false,
        },
      };
    case 'RECEIVE_VERIFY_PASSCODE':
      return {
        ...state,
        passcode: {
          error: false,
          fetching: false,
        },
      };
    case 'REQUEST_VERIFY_PASSCODE_ERROR':
      return {
        ...state,
        passcode: {
          error: true,
          fetching: false,
        },
      };
    case 'REQUEST_UPDATE_PASSCODE':
      return {
        ...state,
        passcode: {
          fetching: true,
          error: false,
        },
      };
    case 'RECEIVE_UPDATE_PASSCODE':
      return {
        ...state,
        passcode: {
          error: false,
          fetching: false,
        },
      };
    case 'REQUEST_UPDATE_PASSCODE_ERROR':
      return {
        ...state,
        passcode: {
          error: true,
          fetching: false,
        },
      };
    case 'REQUEST_CURRENT_SECURITY_QUESTION':
      return {
        ...state,
        questions: {
          ...state.questions,
          fetching: true,
          error: false,
        },
      };
    case 'RECEIVE_CURRENT_SECURITY_QUESTION': {
      const { payload } = action;
      return {
        ...state,
        questions: {
          ...state.questions,
          fetching: false,
          error: false,
          currentQuestion: payload,
        },
      };
    }
    case 'REQUEST_CURRENT_SECURITY_QUESTION_ERROR':
      return {
        ...state,
        questions: {
          ...state.questions,
          error: true,
          fetching: false,
        },
      };

    case 'REQUEST_VERIFY_SECURITY_ANSWER':
      return {
        ...state,
        questions: {
          ...state.questions,
          fetching: true,
          error: false,
        },
      };
    case 'RECEIVE_VERIFY_SECURITY_ANSWER':
      return {
        ...state,
        questions: {
          ...state.questions,
          error: false,
          fetching: false,
        },
      };
    case 'REQUEST_VERIFY_SECURITY_ANSWER_ERROR':
      return {
        ...state,
        questions: {
          ...state.questions,
          error: true,
          fetching: false,
        },
      };
    default:
      (action.type: empty); /* eslint-disable-line */
      return state;
  }
};

export default reducer;
